import {
    GET_SPECIALITY_BY_STYLE_REQUEST,
    GET_SPECIALITY_BY_STYLE_SUCCESS,
    GET_SPECIALITY_BY_STYLE_ERROR,
    GET_CUSTOMER_BY_PO_REQUEST,
    GET_CUSTOMER_BY_PO_SUCCESS,
    GET_CUSTOMER_BY_PO_ERROR,
    GET_SPECIALITY_BY_MONTH_REQUEST,
    GET_SPECIALITY_BY_MONTH_SUCCESS,
    GET_SPECIALITY_BY_MONTH_ERROR
} from "../actions/types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";
const axios = require("axios");

export const getSpecialityByStyle = (token, data, status, ptStatus) => (dispatch) => {
    dispatch({ type: GET_SPECIALITY_BY_STYLE_REQUEST });

    return axios({
        method: "POST",
        url: `${BASEURL}getAll/GetSpecialityReportByStyleWise`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            customer_id: (data.customer === "All" || data.customer === undefined) ? null : data.customer,
            status_id: status.length > 0 ? status.toString() : null,
            pt_status_id: ptStatus.length > 0 ? ptStatus.toString() : null,
            region_id: (data.region === "All" || data.region === undefined) ? null : data.region.toString(),
            from_date: moment(data?.from_date).format("MM-DD-YYYY"),
            to_date: moment(data?.to_date).format("MM-DD-YYYY"),
        }
    })
        .then((response) => {
            return dispatch({ type: GET_SPECIALITY_BY_STYLE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_SPECIALITY_BY_STYLE_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_SPECIALITY_BY_STYLE_ERROR,
                payload: error.response,
            });
        });
};


export const getSpecialityByMonth = (token, data) => (dispatch) => {
    dispatch({ type: GET_SPECIALITY_BY_MONTH_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/GetSpecialityReportByMonth`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            cy_start_date: moment(data.year).startOf("year").format("MM-DD-YYYY"),
            cy_end_date: moment(data.year).endOf("year").format("MM-DD-YYYY"),
            ly_start_date: moment(data.year).subtract(1, "year").startOf("year").format("MM-DD-YYYY"),
            ly_end_date: moment(data.year).subtract(1, "year").endOf("year").format("MM-DD-YYYY"),
            region_id: data.region === "All" || data.region === undefined ? null : data.region,
            gender_id: data.gender === "All" || data.gender === undefined ? null : data.gender,
            sales_person_id: data.salePerson === "All" || data.salePerson === undefined ? null : data.salePerson,
            state_name: data.stateID === "All" || data.stateID === undefined ? null : data.stateID,
            status: data.status_id === "All" || data.status_id === undefined ? null : data.status_id,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_SPECIALITY_BY_MONTH_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_SPECIALITY_BY_MONTH_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_SPECIALITY_BY_MONTH_ERROR,
                payload: error.response,
            });
        });
};


export const getCustomerByPO = (token, data, status, ptStatus) => (dispatch) => {
    dispatch({ type: GET_CUSTOMER_BY_PO_REQUEST });

    return axios({
        method: "POST",
        url: `${BASEURL}getAll/GetCustomerByPONO`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            customer_id: (data.customer === "All" || data.customer === undefined) ? null : data.customer,
            status_id: status.length > 0 ? status.toString() : null,
            pt_status_id: ptStatus.length > 0 ? ptStatus.toString() : null,
            region_id: (data.region === "All" || data.region === undefined) ? null : data.region.toString(),
            from_date: moment.utc(data?.from_date).format("MM-DD-YYYY"),
            to_date: moment.utc(data?.to_date).format("MM-DD-YYYY"),
        }
    })
        .then((response) => {
            return dispatch({ type: GET_CUSTOMER_BY_PO_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_CUSTOMER_BY_PO_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_CUSTOMER_BY_PO_ERROR,
                payload: error.response,
            });
        });
};
